import React from "react";
import axios from "axios";
import { Table, Button, message, Icon, Badge, Input, Popconfirm } from "antd";
import Highlighter from "react-highlight-words";
import { Link, withRouter } from "react-router-dom";
import LeadPreview from "./LeadPreview";
// import LeadScrappingForm from "./LeadScrappingForm";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { isEmpty } from "lodash";

const { Search } = Input;

class LeadList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      singleData: {},
      pagination: {
        current: 1,
        total: 100,
        pageSize: 25,
      },
      selectedRowKeys: [],
      loading: false,
      singleLoading: false,
      searchText: "",
      filteredInfo: null,
      sortedInfo: { sortOrder: "descend", sortField: "modified_on" },
      visisble: false,
      modalVisible: false,
    };

    this.columns = [
      {
        title: props.t("leads.lead_list.name", "Name"),
        dataIndex: "name",
        key: "name",
        sorter: true,
        ellipsis: true,
      },
      {
        title: props.t("leads.lead_list.status", "Status"),
        dataIndex: "status_display",
        key: "status_display",
        sorter: true,
        ellipsis: false,
      },
      {
        title: props.t("leads.lead_list.source", "Source"),
        dataIndex: "source_display",
        key: "source_display",
        sorter: true,
        ellipsis: true,
      },
      {
        title: "Active",
        dataIndex: "is_active",
        key: "is_active",
        sorter: true,
        render: (val) => {
          if (val) {
            return (
              <div>
                <Badge status="success" /> Yes
              </div>
            );
          }
          return (
            <div>
              <Badge status="error" /> No
            </div>
          );
        },
      },
      {
        title: "Modified",
        dataIndex: "modified_on",
        key: "modified_on",
        sorter: true,
        width: 190,
        render: (date) => {
          if (date) return moment(date).format("lll");
        },
      },
      {
        title: props.t("general.actions", "Actions"),
        ellipsis: false,
        fixed: "right",
        render: (text, record, index) => (
          <span>
            <Button
              title={props.t("general.view", "View")}
              icon="eye"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                this.handlePreview(record.id);
              }}
            />
            <Button
              title={props.t("general.edit", "Edit")}
              style={{ marginLeft: "5px" }}
              type="primary"
              size="small"
              icon="edit"
              onClick={(e) => {
                e.stopPropagation();
                props.history.push("/leads/" + record.id, {
                  requestType: "put",
                });
              }}
            />
            <Popconfirm
              title={props.t(
                "tasks.task_list.task_delete",
                "Are you sure want to delete this task?"
              )}
              onConfirm={(event) => {
                event.stopPropagation();
                this.confirmDelete(event, record.id, index);
              }}
              placement="topLeft"
              okText={props.t("general.yes", "Yes")}
              cancelText={props.t("general.no", "No")}
              className="data-id={record.id}"
            >
              <Button
                size="small"
                onClick={(e) => e.stopPropagation()}
                title={props.t("general.delete", "Delete")}
                style={{ marginLeft: "5px" }}
                type="danger"
                icon="delete"
              />
            </Popconfirm>
          </span>
        ),
      },
    ];
  }

  componentWillMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };

    this.fetch({ ...this.state.sortedInfo });
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    let branch = localStorage.getItem("branch");
    if (branch === "0") branch = undefined;
    let search = this.state.searchText;
    if (params.search !== undefined && params.search !== this.state.searchText)
      search = params.search;

    let sortOrder = "";
    if (params.sortOrder === "descend") sortOrder = "-";

    let ordering;
    if (params.sortField && params.sortOrder !== undefined)
      ordering = sortOrder + params.sortField;

    if (!params.page) params.page = this.state.pagination.current;
    axios({
      url: process.env.REACT_APP_AXIOS_URL + "/api/leads/",
      method: "get",
      params: {
        page: params.page,
        page_size: this.state.pagination.pageSize,
        search: search,
        ordering: ordering,
        branch,
      },
    }).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.total = res.data.count;
      pagination.current = params.page;
      this.setState({
        loading: false,
        data: res.data.results,
        pagination: pagination,
      });
    });
  };

  fetchSingle = (params = {}) => {
    const leadID = params.leadID;
    axios
      .get(process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/`)
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          this.setState({
            singleData: res.data,
            singleLoading: false,
            visible: true,
          });
        } else {
          this.props.history.push("/leads");
        }
      })
      .catch((error) => {
        // if (error.response) {
        //     // Request made and server responded
        //     console.log(error.response.data);
        //     console.log(error.response.status);
        //     console.log(error.response.headers);
        // } else if (error.request) {
        //     // The request was made but no response was received
        //     console.log(error.request);
        // } else {
        //     // Something happened in setting up the request that triggered an Error
        //     console.log('Error', error.message);
        // }
        // this.setState({
        //     requestType: "post"
        // })
        // this.props.history.push('/leads/create');
      });
  };

  handleDeleteSelected = (event, something) => {
    this.setState({ loading: true });
    this.state.selectedRowKeys.filter((key, index) => {
      axios
        .delete(process.env.REACT_APP_AXIOS_URL + `/api/leads/${key}/delete/`)
        .then((res) => {
          if (res.status === 204 || res.status === 200) {
            return true;
          }
        });
    });

    let data = this.state.data;
    data = data.filter((item) => {
      return !this.state.selectedRowKeys.includes(item.id);
    });
    setTimeout(() => {
      this.setState({
        data: data,
        selectedRowKeys: [],
        loading: false,
      });
    }, 1000);
  };

  handleExportSelected = async (event, something) => {
    this.setState({ loading: true });

    const data = {
      leads: this.state.selectedRowKeys,
    };

    const searchParams = new URLSearchParams(data);
    window.open(
      `${process.env.REACT_APP_AXIOS_URL}/api/export_clients/?${searchParams}`,
      "_blank"
    );

    this.setState({
      loading: false,
    });
  };

  handleExportAll = async (event, something) => {
    this.setState({ loading: true });

    const data = {
      leads: "all",
    };

    const searchParams = new URLSearchParams(data);
    window.open(
      `${process.env.REACT_APP_AXIOS_URL}/api/export_clients/?${searchParams}`,
      "_blank"
    );

    this.setState({
      loading: false,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;

    const state = {
      pagination: pager,
    };

    if (!isEmpty(sorter)) {
      let sorter_field = sorter.field;
      if (sorter_field && sorter_field.includes("display"))
        sorter_field = sorter_field.substring(0, sorter_field.length - 8);

      state.sortedInfo = {
        sortOrder: sorter.order,
        sortField: sorter_field,
      };
    }
    this.setState(state, () => {
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        ...this.state.sortedInfo,
      });
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  handleSearch = (value) => {
    this.setState({
      searchText: value,
    });
    this.fetch({
      search: value,
      ...this.state.sortedInfo,
    });
  };

  handleDelete(leadID, recordID) {
    axios
      .delete(process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/delete/`)
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          this.fetch(this.state.sortedInfo);
          message.success(
            this.props.t("leads.lead_list.deleted", "Lead deleted")
          );
        } else {
          message.error(
            this.props.t("leads.lead_list.deletion_failed", "Deletion failed")
          );
        }
      });
  }

  confirmDelete(event, leadID, recordID) {
    event.preventDefault();
    this.handleDelete(leadID, recordID);
  }

  handlePreview = (leadID) => {
    this.fetchSingle({
      leadID: leadID,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  render() {
    let { sortedInfo, filteredInfo, selectedRowKeys } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    const { t, history } = this.props;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "delete",
          text: t("general.delete", "Delete"),
          onSelect: this.handleDeleteSelected,
        },
        {
          key: "export",
          text: t("general.export", "Export"),
          onSelect: this.handleExportSelected,
        },
        {
          key: "export-all",
          text: t("general.export_all", "Export All"),
          onSelect: this.handleExportAll,
        },
      ],
    };

    return (
      <div>
        <div
          style={{
            marginBottom: 8,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Search
            placeholder={t("leads.lead_list.search", "Find lead")}
            onSearch={(value) => this.handleSearch(value)}
            style={{ width: 200 }}
          />
          <div style={{}}>
            {/* <Button
              style={{ margin: 8 }}
              type="primary"
              onClick={() => {
                this.setState({
                  modalVisible: true,
                });
              }}
            >
              {t("leads.lead_list.scrap", "Scrap website")}
            </Button> */}
            <Button
              style={{}}
              type="primary"
              onClick={() => {
                history.push("/leads/create", { requestType: "post" });
              }}
            >
              <Icon type="plus" />{" "}
              {t("leads.lead_list.create_lead", "Create Lead")}
            </Button>
          </div>
        </div>
        <Table
          rowSelection={rowSelection}
          columns={this.columns}
          onChange={this.handleTableChange}
          rowKey={(record) => record.id}
          scroll={{ x: 1024 }}
          dataSource={this.state.data}
          size="small"
          rowClassName="table-cursor"
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) =>
                this.props.history.push(`/leads/${record.id}`, {
                  requestType: "put",
                }),
            };
          }}
          pagination={this.state.pagination}
          loading={this.state.loading}
        />
        <LeadPreview
          singleData={this.state.singleData}
          singleLoading={this.state.singleLoading}
          visible={this.state.visible}
          handleState={this.handleState}
        />
        {/* <LeadScrappingForm
          wrappedComponentRef={(form) => (this.formRef = form)}
          visible={this.state.modalVisible}
          // onCreate={this.onCreateScrapping}
          fetch={this.fetch}
          handleState={this.handleState}
          onCancel={() => {
            this.setState({
              modalVisible: false,
            });
          }}
        /> */}
      </div>
    );
  }
}

export default withRouter(withTranslation()(LeadList));



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadList.js